<script>
  export let activeChartType = "scatter";

  let types = [
    { type: "scatter", label: "Scatter plot" },
    { type: "line", label: "Line chart" },
    { type: "benchmark", label: "Benchmark plot" },
    { type: "bar", label: "Bar chart"},
    { type: "map", label: "Map" },
    //{ type: "countryprofile" },
  ];
</script>

{#each types as charttype}
  <img
    class={`chart-type-icon ${
      charttype.type == activeChartType ? "active" : ""
    }`}
    src={`./img/${charttype.type}_icon.svg`}
    alt={charttype.type + " icon"}
    title={charttype.label}
    on:click={() => (activeChartType = charttype.type)}
  />
{/each}

<style>
  .chart-type-icon {
    width: 48px;
    height: 48px;
    margin-right: 6px;
  }
  .active {
    border: 2px solid black;
    border-radius: 5px;
  }
</style>
